import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { AdminPage } from "@features/admin/AdminPage";
import "./styles.css";

const isAdmin = window.location.pathname.startsWith("/admin");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {isAdmin ? <AdminPage /> : <App />}
  </React.StrictMode>,
);
